import 'common/mutating-dot.scss';

interface MutatingDotProps {
  /** Optional override; defaults to "Saving rename" — meaningful for both the
   * panel-pencil-slot and the page-header use sites. */
  ariaLabel?: string;
  /** Optional class merged with `mutating-dot` for layout tweaks. */
  className?: string;
}

/**
 * Pale-honey glowing dot used as a non-interactive in-flight indicator.
 * See `mutating-dot.scss` for the visual; this component just bundles the
 * accessibility attributes so consumers can't drift on them between sites.
 */
export const MutatingDot = ({
  ariaLabel = 'Saving rename…',
  className,
}: MutatingDotProps) => (
  <span
    className={className ? `mutating-dot ${className}` : 'mutating-dot'}
    role="status"
    aria-label={ariaLabel}
    aria-live="polite"
    title="Saving rename…"
  />
);
